import type { PokerHomeGames } from '@ps/web-martech-cms-types';

import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import { PKR_INITIAL_STATE } from '../constants';
import type { PageData } from '../types/common';

import effects from './effects';
import * as reducers from './reducers';
import selectors from './selectors';

export interface HomeGamesWidgetModel extends WidgetModelConfig<PokerHomeGames, PageData> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const homeGamesWidgetModel: HomeGamesWidgetModel = {
  state: PKR_INITIAL_STATE,
  reducers,
  effects,
  selectors
};

export const useHomeGamesWidget: UseWidget<PokerHomeGames, HomeGamesWidgetModel> = useWidget;
